import { createTheme } from '@mui/material';

export const lightTheme = createTheme({
  typography: {
    fontSize: 13,
    fontFamily: [
      'Inter',
      'Roboto',
      'Arial',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#25849D',
    },
    action: {
      active: 'rgba(115, 198, 220, 1)',
      hover: 'rgba(0, 0, 0, 0.04)',
      hoverOpacity: 0.04,
      selected: 'rgba(0, 0, 0, 0.08)',
      selectedOpacity: 0.08
    },
    background: {
      default: '#f1f5f9',
    },
    v4: {
      background: '#f1f5f9',
      surface: '#ffffff',
      border: '#e2e8f0',
      borderDark: '#cbd5e1',
      accent: '#0d9488',
      sidebar: '#1e293b',
      sidebarActive: '#0f172a',
      tableEven: '#f8fafc',
      tableHover: '#f1f5f9',
      tableSelected: '#eef2ff',
      tableSelectedHover: '#dbeafe',
      filterInput: '#e2e8f0',
      filterInputBorder: '#cbd5e1',
    },
    divider: '#0000000f',
    success: {
      main: '#4CAF50',
      contrastText: '#ffff'
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            '&.Mui-focusVisible': { background: 'rgba(0, 0, 0, 0.08)' }
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderColor: '#eeeeee',
          backgroundColor: '#ffffff',
        },
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e293b',
        },
      }
    },
  }
});
